import { Box, Chip, Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material'
import UnfoldMoreOutlinedIcon from '@mui/icons-material/UnfoldMoreOutlined';
import React, { useEffect, useMemo, useState } from 'react'
import CardSkeleton from './CardSkeleton'
import NoDataAvailableCard from './NoDataAvailableCard'
import StatTable from './StatTable'
import GraphCard from './GraphCard'
import { dateMonthYearDateFormat } from '../../../constants'
import moment from 'moment'
import CardFilter from './CardFilter'

const MaintenanceReserveFunds = ({ maintenanceData, isLoading, filters = {}, onFilterChange, currencies = [], cardFiltersDisabled = false }) => {
    const [isMRDrillDown, setMRDrillDown] = useState(false)
    const [selectedEventType, setSelectedEventType] = useState(null)

    const mrFundBalance = maintenanceData?.mr_fund_balance_by_event_type
    const mrFundBalanceOptions = useMemo(() => (
        mrFundBalance?.options
            ? { ...mrFundBalance.options, xAxis: { ...mrFundBalance.options.xAxis, triggerEvent: true, axisLabel: { ...mrFundBalance.options.xAxis?.axisLabel, triggerEvent: true } } }
            : null
    ), [mrFundBalance])

    useEffect(() => {
        setSelectedEventType(null);
        if (!mrFundBalanceOptions) setMRDrillDown(false);
    }, [mrFundBalanceOptions])

    const handleEventTypeClick = (chartParams) => {
        if (chartParams?.dataIndex == null) return
        const row = mrFundBalance?.table?.rows?.[chartParams?.dataIndex]
        if (!row) return
        setSelectedEventType(row?.event_type_id)
        setMRDrillDown(true)
    }

    const mrDrillDownRows = useMemo(() => (
        selectedEventType != null
            ? (mrFundBalance?.table?.rows || []).filter(row => row?.event_type_id === selectedEventType)
            : mrFundBalance?.table?.rows
    ), [selectedEventType, mrFundBalance])

    const selectedEventTypeLabel = useMemo(() => (
        mrFundBalance?.table?.rows?.find(row => row?.event_type_id === selectedEventType)?.event_type
    ), [selectedEventType, mrFundBalance])

    return (
        <div className="contract-analytics-wrapper">
            <div className="ca-page-header">
                <Typography fontSize='15px' fontFamily="Roboto-SemiBold !important">Maintenance Reserve Funds </Typography>
            </div>
            <Grid container spacing={1} mx={1} sx={{ alignItems: 'stretch' }}>
                <Grid size={{ md: 12, xs: 12 }} sx={{ display: 'flex' }}>
                    <Paper className="ca-util-card mr-equal-card">
                        <CardFilter
                            disabled={cardFiltersDisabled}
                            title={<> MR Fund Balance by Event Type <span className="ca-header-subtext" style={{ marginLeft: '10px' }}> {mrFundBalance?.as_of ? `As of ${moment(mrFundBalance?.as_of).format(dateMonthYearDateFormat)}` : ''}</span> </>}
                            filter={filters.mr_fund_balance_by_event_type}
                            onChange={(filter) => onFilterChange('mr_fund_balance_by_event_type', filter)}
                            currencyOptions={currencies}
                            actions={mrFundBalance?.table?.rows?.length > 0 &&
                                <Tooltip title={isMRDrillDown ? "Hide drill down" : "Drill down"}>
                                    <IconButton
                                        size='small'
                                        color={isMRDrillDown ? 'primary' : 'default'}
                                        onClick={() => {
                                            if (isMRDrillDown) setSelectedEventType(null);
                                            setMRDrillDown(!isMRDrillDown);
                                        }}
                                    >
                                        <UnfoldMoreOutlinedIcon fontSize='small' />
                                    </IconButton>
                                </Tooltip>}
                        />
                        {isLoading?.mr_fund_balance_by_event_type ? (
                            <CardSkeleton height='220px' className='ca-graph-container' />
                        ) : (
                            <div className="ca-card-body">
                                <div className="ca-graph-container">
                                    {!mrFundBalanceOptions ? (
                                        <NoDataAvailableCard title='No MR Fund Balance data available' subtext='Try adjusting the date range' />
                                    ) : (
                                        <GraphCard option={mrFundBalanceOptions} height='250px' onChartClick={handleEventTypeClick} widenClickArea/>
                                    )}
                                </div>
                                {isMRDrillDown &&
                                    <div className="ca-drilldown">
                                        {selectedEventTypeLabel &&
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 0.5 }}>
                                                <Typography sx={{ fontSize: 12, color: '#6b7280' }}>Showing:</Typography>
                                                <Chip label={selectedEventTypeLabel} size="small" onDelete={() => setSelectedEventType(null)} />
                                            </Box>}
                                        {mrDrillDownRows?.length ? (
                                            <div className="ca-drilldown-scroll">
                                                <StatTable columns={mrFundBalance?.table?.columns} rows={mrDrillDownRows} />
                                            </div>
                                        ) : selectedEventTypeLabel ? (
                                            <NoDataAvailableCard title={`No data available for ${selectedEventTypeLabel}`} subtext='Try selecting another event type' />
                                        ) : (
                                            <NoDataAvailableCard title='No event type data available' subtext='Try adjusting the date range' />
                                        )}
                                    </div>}
                            </div>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

export default MaintenanceReserveFunds
